// Page title with optional action buttons on the side. With `spread`, the actions
// row fills the width and justifies its own children to both ends — used when a
// screen needs a filter pinned to the start and actions to the end.
export default function PageHeader({ title, children, spread }) {
  return (
    <div className="page-header">
      <h1>{title}</h1>
      <div className={`row${spread ? ' spread' : ''}`}>{children}</div>
    </div>
  );
}
